<template>
    <div id="signUpChoice" class="signUpChoice" :style="styles">
        <div class="signContainer align-items-center fullHeight">
            <div class="pt-4 mx-3">
                <div class="d-flex justify-content-center align-items-center">
                    <img border="0" :src="imgPath" width="120" height="120" alt="">
                </div>
            </div>
            <div class="formCard">
                <h2 class="text-center pageTitles comment-color">メールアドレスで会員登録</h2>
                <p class="comment-color">
                    メールアドレスで仮登録後、会員情報を入力する事で登録できます。
                </p>
                <div class="err_msg" v-if="api_error">
                    <p>
                        <span class="text-danger">{{ this.err_msg_txt }}</span>
                    </p>
                </div>
                <div>
                    <div class="form-group">
                        <input
                            type="text"
                            :class="{ 'is-invalid': valid.mail }"
                            class="form-control"
                            v-model="user_input.mail"
                            placeholder="メールアドレス"
                            @input="checkInputData('mail')"
                            @blur="checkInputData('mail')"
                        />
                        <div class="invalid-feedback" v-if="valid.mail">
                            {{ valid_message.mail }}
                        </div>
                    </div>
                    <div class="form-group">
                        <input
                            type="text"
                            :class="{ 'is-invalid': valid.reMail }"
                            class="form-control"
                            v-model="user_input.reMail"
                            placeholder="メールアドレス（確認）"
                            @input="checkInputData('reMail')"
                            @blur="checkInputData('reMail')"
                        />
                        <div class="invalid-feedback" v-if="valid.reMail">
                            {{ valid_message.reMail }}
                        </div>
                    </div>
                    <button
                        type="button"
                        class="confirmbutton w-100"
                        :class="{ 'mypagedisabledbutton': submit_disabled }"
                        @click="registrationByEmail"
                        :disabled="submit_disabled"
                    >
                        メールアドレスで登録
                    </button>
                </div>
            </div>
            <div class="formCard lineForm" v-if="lineSetting == 1">
                <h2 class="text-center pageTitles comment-color">SNSで会員登録</h2>
                <p class="comment-color">
                    SNSアカウントを使って会員登録できます。
                    <br />ログインが簡単になるため便利です。
                </p>
                <div>
                    <div
                        v-if="lineSetting == 1"
                        @click="registrationByLine"
                        class="lineBtn"
                        tabindex="0"
                    >
                        <div class="lineBtn__inner">LINEで登録</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    REGISTER_MEMBER_TMP,
    GET_SOCIAL_AUTH_URL_FOR_REGISTER
} from "../../constants/signup";
import validater from "../../lib/validater";

export default {
    components: {
        validater
    },
    data() {
        const $t = this.$t.bind(this);
        return {
            valid: {
                mail: false,
                reMail: false
            },
            valid_message: {
                mail: "",
                reMail: ""
            },
            user_input: {
                mail: "",
                reMail: ""
            },
            submit_disabled: true,
            api_error: false,
            lineSetting: 0,
            // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png",
            height: ''
        };
    },
    created() {
        this.initialize();
    },
    mounted() {
        // スタイル変更用の画面高さ取得
        this.height = document.getElementById('signUpChoice').offsetHeight + 'px';
    },
    computed: {
        // バインドするスタイルを生成
        styles () {
            return {
                '--height': this.height
            }
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize() {
            this.lineSetting = this.$store.state.auth.settingValueLine;
            localStorage.removeItem("Auth.SnsQueryToken");
            localStorage.removeItem("Auth.SnsQueryID");
        },
        /** ----------------------------------------------
         * バリデーションチェック
         * ---------------------------------------------- */
        checkInputData: function(el) {
            if (el === "mail") {
                // メールアドレス形式
                if (this.user_input.mail) {
                    if (!validater.checkMail(this.user_input.mail)) {
                        this.valid_message.mail = this.$t(
                            "error.validation.mailFormat"
                        );
                        this.valid.mail = true;
                    } else if (
                        !validater.checkStringLengthMax(
                            this.user_input.mail,
                            256
                        )
                    ) {
                        this.valid_message.mail = this.$t(
                            "error.validation.length.mail"
                        );
                        this.valid.mail = true;
                    } else {
                        this.valid.mail = false;
                    }
                }
            } else if (el === "reMail") {
                // メールアドレス（確認）形式
                if (this.user_input.reMail) {
                    if (!validater.checkMail(this.user_input.reMail)) {
                        this.valid_message.reMail = this.$t(
                            "error.validation.mailFormat"
                        );
                        this.valid.reMail = true;
                    } else if (
                        !validater.checkStringLengthMax(
                            this.user_input.reMail,
                            256
                        )
                    ) {
                        this.valid_message.reMail = this.$t(
                            "error.validation.length.reMail"
                        );
                        this.valid.reMail = true;
                    } else {
                        this.valid.reMail = false;
                    }
                }
            }
            // メールアドレス一致
            if (this.user_input.mail !== "" && this.user_input.reMail !== "") {
                if (!this.valid.mail && !this.valid.reMail) {
                    if (this.user_input.mail !== this.user_input.reMail) {
                        this.valid_message.reMail = this.$t(
                            "error.validation.unmatch"
                        );
                        this.valid.reMail = true;
                    } else {
                        this.valid.reMail = false;
                    }
                }
            }
            this.disabledCheck();
        },
        /** ----------------------------------------------
         * メールアドレス登録ボタン制御処理
         * ---------------------------------------------- */
        disabledCheck: function() {
            this.api_error = false;
            if (this.user_input.mail !== "" && this.user_input.reMail !== "") {
                if (this.valid.mail === false && this.valid.reMail === false) {
                    this.submit_disabled = false;
                } else {
                    this.submit_disabled = true;
                }
            } else {
                this.submit_disabled = true;
            }
        },
        /** ----------------------------------------------
         * メールアドレス登録ボタン押下時処理
         * ---------------------------------------------- */
        registrationByEmail: function() {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo
                .mutate({
                    mutation: REGISTER_MEMBER_TMP,
                    variables: {
                        email: this.user_input.mail,
                        email_confirmation: this.user_input.reMail,
                        golf_group_code: process.env.MIX_GROUP_CODE,
                        golf_code: this.$route.query.gc,
                        member_rank: this.$route.query.ud,
                        token: this.$route.query.token,
                        id: this.$route.query.id,
                        companionId: this.$route.query.cid
                    }
                })
                .then(res => {
                    if (!this.$route.query.gc || !this.$route.query.ud) {
                        this.$router.push("/signup-provisional");
                    } else {
                        this.$router.push("/signup-provisional?gc=" + this.$route.query.gc + "&ud=" + this.$route.query.ud);
                    }
                })
                .catch(error => {
                    if (error.graphQLErrors[0].message == "The given data was invalid.") {
                        this.err_msg_txt = error.graphQLErrors[0].extensions.validation.email[0];
                    } else {
                        this.err_msg_txt = this.$t("error.validation.systemError");
                    }
                    this.api_error = true;
                    this.$store.commit("loading/setIsLoading", false);
                });
        },
        /** ----------------------------------------------
         * LINEで登録ボタン押下時処理
         * ---------------------------------------------- */
        registrationByLine: function() {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo
                .query({
                    query: GET_SOCIAL_AUTH_URL_FOR_REGISTER,
                    variables: {
                        golf_group_code: process.env.MIX_GROUP_CODE,
                        golf_code: this.$route.query.gc,
                        member_rank: this.$route.query.ud
                    }
                })
                .then(res => {
                    this.url = res.data.getSocialAuthUrl.url;
                    window.location.href = this.url;
                    if (this.$route.query.id) {
                        localStorage.setItem("Auth.snsQueryId", this.$route.query.id);
                    }
                    if (this.$route.query.token) {
                        localStorage.setItem("Auth.snsQueryToken", this.$route.query.token);
                    }
                })
                .catch(error => {
                    this.$store.commit("loading/setIsLoading", false);
                });
        }
    }
};
</script>

<style scoped>

@media screen and (max-width: 575px) {
    .row{
        flex-direction: column-reverse;
    }
}

.container {
    background-image: initial;
}

</style>
